import {
  Card,
  Dropdown,
  FloatButton,
  Pagination,
  Tooltip,
  Select,
  Input,
  Switch,
  Button,
} from "antd"
import React, { useState } from "react"
import { DownOutlined, PlusOutlined } from "@ant-design/icons"
import { SearchOutlined } from "@ant-design/icons"
import TableInput from "src/components/TableInput"

const AntdMobileTable = ({
  elementsList,
  elementsListLoading,
  setIsOpenAddEditModal,
  setIsOpenDeleteModal,
  page,
  setPage,
  pageSize,
  setPageSize,
  items,
  onChange,
  filterOptionsArr,
  clickOnAction,
  handlePaginationChange,
  searchInput,
  onClickSearchItem,
  mnemo,
  handleSwitchChange,
}) => {
  const [filterOption, setFilterOption] = useState(0)
  const [filterMeaning, setFilterMeaning] = useState(1)

  const [selectedKeys, setSelectedKeys] = useState([])

  const fillterHandle = (e, filOpt = filterOption) => {
    const pagination = {
      position: ["bottomRight"],
      pageSizeOptions: [20, 40, 60, 80],
      defaultPageSize: pageSize,
      onChange: (page, pageSize) => {
        setPage(page)
        setPageSize(pageSize)
      },
      defaultCurrent: page,
      total: elementsList?.data?.value?.totalCount,
      current: page,
    }
    onChange(
      pagination,
      {},
      {
        column: { dataIndex: filterOptionsArr[filOpt].index },
        order: e == 3 ? "ascend" : e == 2 ? "descend" : undefined,
      }
    )
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 10,
          marginBlockEnd: 15,
        }}
      >
        <Pagination
          defaultCurrent={page}
          pageSize={20}
          showSizeChanger={false}
          current={page}
          onChange={(page, pageSize) => {
            handlePaginationChange(page, pageSize)
          }}
          total={elementsList?.data?.value?.totalCount}
          page={page}
        />
        <Select
          style={{ width: "88%" }}
          value={filterOption}
          onChange={(e) => {
            setFilterOption(e)
            if (e == 0) {
              setFilterMeaning(1)
              fillterHandle(1, 0)
            } else {
              fillterHandle(filterMeaning)
            }
          }}
          options={filterOptionsArr}
        />
        {filterOption !== 0 ? (
          <>
            <Select
              style={{ width: "88%" }}
              value={filterMeaning}
              onChange={(e) => {
                setFilterMeaning(e)
                fillterHandle(e)
              }}
              options={[
                { label: "Не использовать", value: 1 },
                { label: "По возрастанию", value: 2 },
                { label: "По убыванию", value: 3 },
              ]}
            />
            <div
              style={{
                padding: 8,
                width: "92%",
              }}
              onKeyDown={(e) => e.stopPropagation()}
            >
              <div>
                {
                  <Input
                    ref={searchInput}
                    placeholder={`Искать ${filterOptionsArr[filterOption].title}`}
                    onChange={(e) => {
                      setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }}
                    onPressEnter={() =>
                      onClickSearchItem(
                        selectedKeys,
                        filterOptionsArr[filterOption].index
                      )
                    }
                    style={{
                      marginBottom: 8,
                      display: "block",
                    }}
                  />
                }
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  type='primary'
                  onClick={() =>
                    onClickSearchItem(
                      selectedKeys,
                      filterOptionsArr[filterOption].index
                    )
                  }
                  icon={<SearchOutlined />}
                  size='small'
                  style={{
                    width: "40%",
                  }}
                >
                  Искать
                </Button>
                <Button
                  onClick={() => {
                    setSelectedKeys([])
                    setFilterMeaning(1)
                    setFilterOption(0)
                    fillterHandle(1, 0)
                    onClickSearchItem([], undefined)
                  }}
                  size='small'
                  style={{
                    width: "40%",
                  }}
                >
                  Сбросить
                </Button>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        {elementsList?.data?.value?.rows.map((element) => {
          return (
            <Card
              loading={elementsListLoading}
              title={`${filterOptionsArr[1].title} № ${element.id}`}
              extra={
                <Dropdown
                  menu={{
                    items,
                  }}
                >
                  <a
                    onClick={() => {
                      clickOnAction(element)
                    }}
                    className='text-primary text-decoration-none'
                  >
                    Действия <DownOutlined />
                  </a>
                </Dropdown>
              }
              style={{ width: 330, marginTop: 16 }}
              key={element.id}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  {filterOptionsArr[3]["index"] == "value" ? (
                    ""
                  ) : (
                    <>
                      {filterOptionsArr.map((el, index) => {
                        if (index >= 2) {
                          return <div key={index}>{`${el.title}:`}</div>
                        }
                      })}
                    </>
                  )}
                </div>
                <div>
                  {filterOptionsArr.map((el, index) => {
                    if (index >= 2) {
                      if (el.index == "fileName") {
                        return (
                          <div key={index}>
                            <a
                              href={`http://83.220.173.243/Content/${
                                element[el.index]
                              }`}
                              target='_blank'
                            >
                              {element[el.index].toString().slice(0, 15)}
                            </a>
                          </div>
                        )
                      }
                      if (el.index === "isRequired") {
                        return (
                          <div>
                            {
                              <Switch
                                disabled={
                                  !mnemo?.children[0]?.children?.find(
                                    (el) => el.mnemo === "updateBtn"
                                  )
                                }
                                size='small'
                                value={element.isRequired}
                                onChange={() => handleSwitchChange(element)}
                              />
                            }
                          </div>
                        )
                      }
                      if (el.index == "value") {
                        return (
                          <TableInput
                            defaultValue={element.value}
                            completeHandler={(value) => {
                              clickOnAction(element.id, value)
                            }}
                            disabled={
                              !mnemo?.children[0]?.children?.find(
                                (el) => el.mnemo === "updateBtn"
                              )
                            }
                          />
                        )
                      }
                      if (el.index === "isActive") {
                        return (
                          <div>
                            {
                              <Switch
                                disabled={
                                  !mnemo?.children?.find(
                                    (el) => el.mnemo === "activate"
                                  )
                                }
                                size='small'
                                value={element.isActive}
                                onChange={() => handleSwitchChange(element)}
                              />
                            }
                          </div>
                        )
                      }
                      return (
                        <div key={index}>
                          {element[el.index] ? (
                            <Tooltip title={element[el.index]}>
                              {element[el.index].toString().slice(0, 15)}
                            </Tooltip>
                          ) : (
                            "-"
                          )}
                        </div>
                      )
                    }
                  })}
                </div>
              </div>
            </Card>
          )
        })}
        <FloatButton
          style={{ right: 24 }}
          type='primary'
          icon={<PlusOutlined />}
          onClick={() => {
            setIsOpenAddEditModal({ open: true, flag: "add" })
          }}
        />
      </div>
    </>
  )
}

export default AntdMobileTable
